import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import ShareCode from '@/views/share/ShareCode.vue'
import ShareRulezh from '@/views/share/ShareRulezh.vue'
import ShareRulemy from '@/views/share/ShareRulemy.vue'
import ShareRuleen from '@/views/share/ShareRuleen.vue'
import Register from '@/views/register/Register.vue'
import RegisterSuccess from '@/views/register/RegisterSuccess.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/shareCode'
  },
  {
    path: '/shareCode',
    name: 'ShareCode',
    component: ShareCode,
    meta: {
      title: '转介',
      // keepAlive: true, // init 缓存
      isDynamic: true, // 动态缓存
      isApp: true
    }
  },
  {
    path: '/shareRulezh',
    name: 'ShareRulezh',
    component: ShareRulezh,
    meta: {
      title: '规则说明'
    }
  },
  {
    path: '/shareRulemy',
    name: 'ShareRulemy',
    component: ShareRulemy,
    meta: {
      title: '规则说明'
    }
  },
  {
    path: '/shareRuleen',
    name: 'ShareRuleen',
    component: ShareRuleen,
    meta: {
      title: '规则说明'
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      title: '注册'
    }
  },
  {
    path: '/registerSuccess',
    name: 'RegisterSuccess',
    component: RegisterSuccess,
    meta: {
      title: '注册成功'
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
